import { Box, ContentBlock } from 'braid-design-system';
import React, { type ReactNode } from 'react';

import ConditionalWrapper from 'src/components/ConditionalWrapper/ConditionalWrapper';

import * as styles from './style.css';

interface Props {
  children: ReactNode;
  highlightBackground?: boolean;
}

const Section = ({ children, highlightBackground = false }: Props) => (
  <ConditionalWrapper
    condition={highlightBackground}
    wrapper={(childNode: ReactNode) => (
      <Box
        className={styles.brandLight}
        paddingBottom="gutter"
        paddingTop="xlarge"
      >
        {childNode}
      </Box>
    )}
  >
    <ContentBlock>
      <Box paddingX={['medium', 'medium', 'none']}>{children}</Box>
    </ContentBlock>
  </ConditionalWrapper>
);

export default Section;
